function takeApiUrl() {
	if (process.env.VUE_APP_CONFIG == "development") {
		return process.env.VUE_APP_API_DEVELOPMENT;
	} else {
		return process.env.VUE_APP_API_PRODUCTION;
	}
}
let apiUrl = takeApiUrl();

export default {
	// Course
	GetCourseList: apiUrl + "/api/course/find/",
	UpdateCourse: apiUrl + "/api/course/update/",
	DeleteCourse: apiUrl + "/api/course/delete/",
	CreateCourse: apiUrl + "/api/course/create/",
	GetCourse: apiUrl + "/api/course/",
	// News
	GetNewsList: apiUrl + "/api/news/find/",
	GetLatestNewsList: apiUrl + "/api/news/getLatestNews/",
	UpdateNews: apiUrl + "/api/news/update/",
	DeleteNews: apiUrl + "/api/news/delete/",
	CreateNews: apiUrl + "/api/news/create/",
	GetNews: apiUrl + "/api/news/",
	// Staff
	GetStaffList: apiUrl + "/api/staff/find/",
	UpdateStaff: apiUrl + "/api/staff/update/",
	DeleteStaff: apiUrl + "/api/staff/delete/",
	CreateStaff: apiUrl + "/api/staff/create/",
	GetStaff: apiUrl + "/api/staff/",
	// Recruitment
	GetRecruitmentList: apiUrl + "/api/recruitment/find/",
	UpdateRecruitment: apiUrl + "/api/recruitment/update/",
	DeleteRecruitment: apiUrl + "/api/recruitment/delete/",
	CreateRecruitment: apiUrl + "/api/recruitment/create/",
	GetRecruitment: apiUrl + "/api/recruitment/",
	// User
	CheckLogin: apiUrl + "/api/user/checklogin/",
	GetUserList: apiUrl + "/api/user/find/",
	UpdateUser: apiUrl + "/api/user/update/",
	DeleteUser: apiUrl + "/api/user/delete/",
	CreateUser: apiUrl + "/api/user/create/",
	GetUser: apiUrl + "/api/user/",
	// Cooperation
	GetCooperationList: apiUrl + "/api/cooperation/find/",
	UpdateCooperation: apiUrl + "/api/cooperation/update/",
	DeleteCooperation: apiUrl + "/api/cooperation/delete/",
	CreateCooperation: apiUrl + "/api/cooperation/create/",
	GetCooperation: apiUrl + "/api/cooperation/",
	// WebConfig
	GetWebConfigList: apiUrl + "/api/web-config/find/",
	UpdateWebConfig: apiUrl + "/api/web-config/update/",
	// Upload
	UploadSingleFile: apiUrl + "/api/upload/single-file",
};
